import { useState } from "react";
import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setLogout } from "../features/authSlice";

import LoadingOverlay from "../ui/LoadingOverlay";
import MoonLoader from "react-spinners/MoonLoader";
import L from "leaflet";
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
// import { useMap } from "https://cdn.esm.sh/react-leaflet/hooks";
import Header from "../components/Header";

import popupIcon from "../popup_icon2.png"; // path to your custom icon
import style from "./MapResults.module.css";
import { toast } from "react-toastify";
// Fix default icon path issue (optional but useful in some setups)

// Custom component to update the map center
function UpdateMapCenter({ center }) {
  const map = useMap();

  useEffect(() => {
    map.setView(center); // Update the map's center
  }, [center, map]);
  return null;
}

//  '../../public/images/popup-icon.png'
function MapResults() {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const mapPosition = useSelector((state) => state.model.mapPosition);
  const { token, user } = useSelector((state) => state.auth);
  const [llmMessage, setLlmMessage] = useState("");
  // const { cityName } = useSelector((state) => state.model);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const customIcon = L.icon({
    // iconUrl: `${process.env.PUBLIC_URL}/images/popup-icon.png`, // your custom icon
    iconUrl: popupIcon, // your custom icon
    iconSize: [24, 24],
    // iconAnchor: [16, 32], // position the icon correctly
    // popupAnchor: [0, -32],
    // shadowUrl: iconShadow,
    // shadowSize: [41, 41],
  });
  useEffect(() => {
    async function fetchData() {
      const controller = new AbortController(); // Create an AbortController instance
      const timeoutId = setTimeout(() => controller.abort(), 5000); // Set timeout to 5 seconds
      const url = `https://api.up2smart.com:5001/latest-images?count=10&city=${encodeURIComponent(
        user.city
      )}`;
      // console.log(url);
      // if (!cityName) {
      //   return;
      // }
      try {
        setIsLoading(true);
        const response = await fetch(url, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`, // Add the Authorization header
          },
          // body: JSON.stringify({ city: user.city }),
          signal: controller.signal, // Pass the AbortController signal
        });
        // console.log(response);
        if (!response.ok) {
          if (response.status === 401) {
            toast.error("Unauthorized access. Please login again.");
            dispatch(setLogout());
            navigate("/login");
          }
          throw new Error("Cannot fetch data from the server");
        }

        const data = await response.json();
        // console.log(data);
        setData(data);
        toast.success("Map Loaded successfully..");
        toast.info(`${data.length} images`, {
          // position: 'top-center',
        });
      } catch (error) {
        if (error.name === "AbortError") {
          toast.error("Request timed out. Please try again.");
        } else {
          console.error("Error fetching data:", error);
          toast.error(error.message);
        }
      } finally {
        clearTimeout(timeoutId); // Clear the timeout
        setIsLoading(false);
      }
    }
    fetchData();
  }, [token, user.city, dispatch, navigate]);

  async function handleLLM(item) {
    setLlmMessage(""); // Update the state with the LLM response
    const url = "http://164.92.204.190:11434/api/generate";

    const payload = {
      model: "gemma3:4b",
      stream: false,
      prompt:
        "what is in this image?! please focuse on trash pins and carbage and every thing near it. make the answer as report",
      // "prompt": "can you see any trash objects near to trash pins, if yes please tell me what are they",
      images: [item.image_base64], // Use the base64 image from the clicked item
      // // "messages": [
      // //   {
      // //     "role": "user",
      // //   },
      // ],
    };
    // console.log(item.image_base64)
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          // Authorization: `Bearer ${token}`, // Add token if required
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error("Failed to fetch LLM response");
      }
      // console.log("LLM Response:", response);
      // const responseText = await response.text();
      // console.log("Raw Response:", responseText);
      const data = await response.json();
      // console.log("LLM Response:", data.response);

      // Extract the description from the response
      const description = data.response || " ";
      setLlmMessage(description); // Update the state with the LLM response
      // toast.success("LLM Response Received!");
    } catch (error) {
      console.error("Error interacting with LLM:", error);
      setLlmMessage(" ");
      toast.error("Error interacting with LLM");
    }
  }
  return (
    <>
      <Header />
      <div className={style.mapContainer}>
        {isLoading ? (
          <LoadingOverlay isVisible={isLoading} message="Loading Map...">
            <MoonLoader color="#00BFFF" size={50} />
          </LoadingOverlay>
        ) : (
          <MapContainer
            center={mapPosition}
            zoom={14}
            scrollWheelZoom={true}
            className={style.map}
          >
            {/* Update the map center when mapPosition changes */}
            <UpdateMapCenter center={mapPosition} />
            <TileLayer
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              // url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}"
            />
            {data.map((item, index) => {
              const pos = [item.latitude, item.longitude];
              return (
                <Marker
                  position={pos}
                  icon={customIcon}
                  key={item.filename}
                  eventHandlers={{
                    click: () => handleLLM(item),
                  }}
                >
                  <Popup>
                    <div className={style.popup}>
                      <img
                        src={`data:image/png;base64,${item.image_base64}`}
                        alt="results from API"
                      />
                      {llmMessage ? (
                        <span>{llmMessage}</span>
                      ) : (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            flexDirection: "column",
                          }}
                        >
                          <MoonLoader color="#00BFFF" size={30} />
                          <span>wait get LLM response</span>
                        </div>
                      )}
                    </div>
                  </Popup>
                </Marker>
              );
            })}
          </MapContainer>
        )}
      </div>
    </>
  );
}

export default MapResults;
